/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import menu from './menu.svg'
import menuClose from './close-menu.svg'

const Menu = ({ onClick, isOpen }) => {
  return (
    <div className='text-center cursor-pointer lg:mt-8 xl:mt-6'>
      <img style={{ pointerEvents: "all" }} src={isOpen ? menuClose : menu} alt='Menu icon' onClick={onClick} />
    </div>
  )
}

export default Menu
